var getPhoneNumberNormalized = function (phoneNumber) {
    var _a = phoneNumber.match(/(\d{0,3})(\d{0,3})(\d{0,4})/) || [], part1 = _a[1], part2 = _a[2], part3 = _a[3];
    var lastPart = part2.length === 3 && part3 ? "".concat(part2, "-").concat(part3) : part2;
    return "".concat(part1 ? "(".concat(part1, ")") : '').concat(part2 ? " ".concat(lastPart) : '');
};
export default getPhoneNumberNormalized;
//# sourceMappingURL=getPhoneNumberNormalized.js.map